'use client'

import { Image } from '@vinted/web-ui'

import { PricingRulesModel, EscrowFees } from '@marketplace-web/escrow-pricing/escrow-pricing-data'
import { useAsset } from '@marketplace-web/shared/assets'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  priceRules: PricingRulesModel
}

const AdditionalInformationSection = ({ priceRules }: Props) => {
  const asset = useAsset('/assets/available-discounts')
  const translate = useTranslate('available_discounts')
  const hasSippingFees = priceRules.some(rule => rule.type === EscrowFees.Shipping)

  return (
    <section className="available_discounts__additional-information-section">
      <div className="available_discounts__additional-information-image">
        <Image
          src={asset('women-browsing-on-mobile-phone.jpg')}
          scaling="cover"
          loading="lazy"
          alt=""
        />
      </div>
      <div className="available_discounts__additional-information-content">
        <h3 className="available_discounts__additional-information-title">
          {translate('additional_notes.title')}
        </h3>
        <ul className="available_discounts__additional-information-text">
          <li className="available_discounts__additional-information-list-item">
            {translate('additional_notes.discount_apply_automatically')}
          </li>
          <li className="available_discounts__additional-information-list-item">
            {translate('additional_notes.only_largest_discount_apply')}
          </li>
          {hasSippingFees && (
            <li className="available_discounts__additional-information-list-item">
              {translate('additional_notes.vinted_shipping_only')}
            </li>
          )}
          {hasSippingFees && (
            <li className="available_discounts__additional-information-list-item">
              {translate('additional_notes.available_shipping_differences')}
            </li>
          )}
        </ul>
      </div>
    </section>
  )
}

export default AdditionalInformationSection
